import { Box, Dialog, DialogContent, DialogTitle, IconButton, CircularProgress } from "@mui/material";
import React, { FC } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

// import "./vehicleLogDetailsDialog.css";
import { IVehicleLogRowDetails } from "..";
import { IGetAlertEventsResponseData } from "../../../types";
import VehicleLogContent from "../VehicleLogContent";

interface IVehicleLogDetailsDialogProps {
	open: boolean;
	vehicleLogDetails: IVehicleLogRowDetails | null;
	previousButtonDisabled?: boolean;
	nextButtonDisabled?: boolean;
	pageChangeLoading?: boolean;
	onClose: (success?: boolean) => void;
	onPrevious: (vehicleLogId: number) => void;
	onNext: (vehicleLogId: number) => void;
	onUpdated: (eventDetails: IGetAlertEventsResponseData) => void;
	onChallanGenerated: (eventId: number, challanGenerated: boolean, retryChallan: boolean) => void;
}

const VehicleLogDetailsDialog: FC<IVehicleLogDetailsDialogProps> = (props) => {
	const {
		open,
		vehicleLogDetails,
		previousButtonDisabled,
		nextButtonDisabled,
		pageChangeLoading,
		onClose,
		onPrevious,
		onNext,
		onUpdated,
		onChallanGenerated
	} = props;

	function handleUpdateSuccess(eventDetails: IGetAlertEventsResponseData) {
		onUpdated(eventDetails);
		// onClose(true);
	}

	return (
		<Dialog open={open} onClose={() => onClose()} fullWidth maxWidth="xl" PaperProps={{ sx: { overflow: "visible" } }}>
			<DialogTitle textAlign="center" color="white" classes={{ root: `dialog-title-root primary` }}>
				Evidence Validation
				<Box className="close-dialog-icon-wrapper">
					<IconButton color="inherit" onClick={() => onClose()}>
						<CloseIcon color="inherit" />
					</IconButton>
				</Box>
			</DialogTitle>

			<DialogContent classes={{ root: "dialog-content-root" }} sx={{ background: "#f8f8f8" }}>
				{pageChangeLoading ? (
					<DialogContent classes={{ root: "vehicle-log-details-dialog-content" }}>
						<Box
							sx={{
								width: "100%",
								height: "100%",
								display: "flex",
								alignItems: "center",
								justifyContent: "center"
							}}
						>
							<CircularProgress size={32} />
						</Box>
					</DialogContent>
				) : (
					<>
						<Box className="dialog-arrow-wrapper prev">
							<IconButton
								disabled={previousButtonDisabled}
								onClick={() => onPrevious(vehicleLogDetails?.id ?? 0)}
								classes={{ root: "dialog-arrow" }}
							>
								<ArrowBackIosNewIcon />
							</IconButton>
						</Box>

						<VehicleLogContent
							vehicleLogDetails={vehicleLogDetails}
							previousButtonDisabled={previousButtonDisabled}
							nextButtonDisabled={nextButtonDisabled}
							onUpdated={handleUpdateSuccess}
							onChallanGenerated={onChallanGenerated}
						/>

						<Box className="dialog-arrow-wrapper next">
							<IconButton
								disabled={nextButtonDisabled}
								onClick={() => onNext(vehicleLogDetails?.id ?? 0)}
								classes={{ root: "dialog-arrow" }}
							>
								<ArrowForwardIosIcon />
							</IconButton>
						</Box>
					</>
				)}
			</DialogContent>
		</Dialog>
	);
};

export default VehicleLogDetailsDialog;
